import { notification } from 'antd';
import type { Dispatch } from 'redux';
import { setTokens } from '../../../services/auth';
import { authChallenge, signInSuccess } from '../../../redux/actions/authActions';
import { getUserAccessPermissions } from '../../../redux/UserManagement/actions';
import { logUserLoginAudit } from './authAudit';

type SignInResult = {
  challengeName?: string;
  attributes?: Record<string, unknown>;
  signInUserSession?: {
    idToken?: { payload?: { sub?: string } };
  };
};

export async function finalizeLogin(
  signInResult: SignInResult,
  email: string,
  dispatch: Dispatch
): Promise<void> {
  if (signInResult?.challengeName) {
    dispatch(authChallenge(signInResult.challengeName, signInResult));
    return;
  }

  const cognitoSub =
    (typeof signInResult?.attributes?.sub === 'string' ? signInResult.attributes.sub : '') ||
    signInResult?.signInUserSession?.idToken?.payload?.sub ||
    '';

  localStorage.setItem(
    'user',
    JSON.stringify(signInResult?.attributes ?? signInResult?.signInUserSession?.idToken?.payload ?? {})
  );

  notification.destroy();
  notification.success({ message: 'Login Successful.' });

  await setTokens(signInResult);
  await logUserLoginAudit(signInResult, email.trim());

  if (cognitoSub) {
    dispatch(getUserAccessPermissions(cognitoSub));
  }

  dispatch(signInSuccess({ res: signInResult }));
}
